import React from 'react';
import { Row, Col } from 'antd';
import { SectionTitle } from 'components/Section';
import Link from 'next/link';
import CompanyImage from 'components/CompanyImage';

interface Props {
    companies: Company[];
}

const RelatedCompanies = ({ companies }: Props): JSX.Element => {
    return (
        <Row>
            <Col span={24}>
                <SectionTitle title="Powiązane firmy" level={3} />
            </Col>
            {companies.map((company) => (
                <Col span={8} key={company.seoSlug}>
                    <Link href={`/katalog-firm/${company.seoSlug}`}>
                        <CompanyImage patron={company} />
                    </Link>
                </Col>
            ))}
        </Row>
    );
};

RelatedCompanies.whyDidYouRender = false;

export default RelatedCompanies;
